import { getCsrf } from './auth';

/**
 * Envuelve fetch una sola vez para toda la app:
 *   - añade el token CSRF a las peticiones de escritura hacia nuestra API
 *   - si el servidor responde 401 (sesión vencida), manda al login
 *
 * Se hace en un único lugar porque home.js tiene muchas llamadas fetch dispersas;
 * tocarlas una por una sería frágil. Solo afecta a las rutas propias (/ApiPrubeaReact).
 */
export function instalarInterceptorHttp() {
    const original = window.fetch;
    const escritura = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

    window.fetch = async (recurso, opciones = {}) => {
        const url = typeof recurso === 'string' ? recurso : recurso.url;
        const esNuestra = url && url.includes('/ApiPrubeaReact/');
        const metodo = (opciones.method || 'GET').toUpperCase();

        if (esNuestra && escritura.has(metodo)) {
            opciones.headers = { ...(opciones.headers || {}), 'X-CSRF': getCsrf() || '' };
        }

        const resp = await original(recurso, opciones);

        // Sesión vencida en una ruta propia: no en /auth/* para no crear un bucle.
        if (esNuestra && resp.status === 401 && !url.includes('/auth/')) {
            if (window.location.hash !== '#/signin' && !window.location.pathname.endsWith('/signin')) {
                window.location.assign('/signin');
            }
        }

        return resp;
    };
}
